import { createContext, useContext, type ReactNode } from "react";

export interface ConfirmOptions {
  title: ReactNode;
  description?: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
}

export interface PromptOptions {
  title: ReactNode;
  description?: ReactNode;
  label?: string;
  defaultValue?: string;
  placeholder?: string;
  inputMode?: "text" | "url";
  confirmLabel?: string;
  cancelLabel?: string;
}

export interface DialogApi {
  confirm: (options: ConfirmOptions) => Promise<boolean>;
  prompt: (options: PromptOptions) => Promise<string | null>;
}

export const DialogContext = createContext<DialogApi | null>(null);

function useDialogApi(): DialogApi {
  const api = useContext(DialogContext);
  if (!api) throw new Error("DialogProvider is missing");
  return api;
}

/** `window.confirm` yerine: `if (!(await confirm({ title }))) return;` */
export function useConfirm() {
  return useDialogApi().confirm;
}

/** `window.prompt` yerine: iptalde `null`, aksi halde girilen metin. */
export function usePrompt() {
  return useDialogApi().prompt;
}
